import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import styles from './styles.module.scss';

interface AvailableLeague {
  id: number;
  name: string;
  externalId: string;
  country: string | null;
  logoUrl: string | null;
  status: string;
  season: string | null;
}

interface LeagueSelectStepProps {
  leagues: AvailableLeague[];
  selectedLeagueId: number | null;
  onSelectAndAdvance: (id: number) => void;
  isLoading: boolean;
}

const LeagueSelectStep: React.FC<LeagueSelectStepProps> = ({
  leagues,
  selectedLeagueId,
  onSelectAndAdvance,
  isLoading,
}) => {
  const { t } = useTranslation('tournament');

  if (isLoading) {
    return null;
  }

  if (leagues.length === 0) {
    return <div className={styles.emptyLeagues}>{t('noAvailableLeagues')}</div>;
  }

  return (
    <>
      <div className={styles.leagueGrid}>
        {leagues.map((league) => (
          <div
            key={league.id}
            data-testid="league-card"
            data-league-id={league.id}
            className={classNames(
              styles.leagueCard,
              selectedLeagueId === league.id && styles.leagueCardSelected,
            )}
            onClick={() => onSelectAndAdvance(league.id)}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => e.key === 'Enter' && onSelectAndAdvance(league.id)}
          >
            {league.logoUrl ? (
              <img src={league.logoUrl} alt={league.name} className={styles.leagueLogo} />
            ) : (
              <span className={styles.leagueIconFallback}>{'\u{1F3DF}\uFE0F'}</span>
            )}
            <span className={styles.leagueCardName}>{league.name}</span>
            <div className={styles.leagueCardMeta}>
              {league.country && <span>{league.country}</span>}
              {league.season && <span>{league.season}</span>}
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default LeagueSelectStep;
